module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/subhead-grid/subhead-grid.component.css
// module id = ./src/app/finance/subhead-grid/subhead-grid.component.css
// module chunks = main